/* eslint-disable react/jsx-no-useless-fragment */
import { PureComponent } from 'react';

import './FontArabic.style';

/** @namespace Geely/Component/FontArabic/Component */
export class FontArabicComponent extends PureComponent {
    render() {
        return (
            <></>
        );
    }
}

export default FontArabicComponent;
